import { useEffect, useState } from "react";
import InfoIconWithTooltip from "../../UI/InfoIconWithTooltip/InfoIconWithTooltip";

import styles from "./ChecklistRow.module.css";
import srdStles from "../../sharedStyles/QuestionsListPagesRow.module.css";

const ChecklistRow = (props) => {
  const [displayButtons, setDisplayButtons] = useState(false);
  const [title, setTitle] = useState(props.title);
  // const [questionType, setQuestionType] = useState(props.questionType);
  // const [questionTypeSelected, setQuestionTypeSelected] = useState(false);
  // const [displayQuestionTypeButtons, setDisplayQuestionTypeButtons] = useState(false);
  
  const [isInfoIconVisible, setIsInfoIconVisible] = useState(false);

  useEffect(() => {
    setTitle(props.title);
    // console.log("pos: ", pos, " type: ", type ? (`${type} ${title ? title.substring(0,20) : "no title"}`) : (`question: ${title ? title.substring(0,20) : ""}`))
    // setQuestionType(props.questionType);
  }, [props]);

  // const buttonStyle = `${styles.Button} ${styles.checkedButton}`;
  let titleStyle = "";
  let type = props.type;
  let pos = props.pos; // position/index of row in the array
  if (type === "principio") titleStyle = styles.principio;
  else if (type === "requisito") titleStyle = styles.requisito;
  else if (type === "ambito") titleStyle = styles.ambito;

  const showQuestionButtons = (e) => {
    e.preventDefault();
    setDisplayButtons(true);
  };

  const hideQuestionButtons = (e) => {
    e.preventDefault();
    setDisplayButtons(false);
  };

  const showInfoIcon = (e) => {
    e.preventDefault();
    setIsInfoIconVisible(true);
  };

  const hideInfoIcon = (e) => {
    e.preventDefault();
    setIsInfoIconVisible(false);
  };

  const changeTextareaHeight = (e) => {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  // const showQuestionTypeButtonsHandler = () => {
  //   setDisplayQuestionTypeButtons(true);
  // };

  // const hideQuestionTypeButtonsHandler = () => {
  //   setDisplayQuestionTypeButtons(false);
  // };

  // const determineQuestionType = (questionT) => {
  //   setDisplayQuestionTypeButtons(false);
  //   setQuestionTypeSelected(true);
  //   props.addQuestion(pos, questionT);
  // };

  const addQuestionButton = (
    <button
      onClick={
        () => {props.addQuestion(pos)}
      }
      className={`${styles.addQuestionButton} ${displayButtons ? "visible" : "invisible"}`}
    ></button>
  );

  const questionsButtons = (
    <div
      className={`${displayButtons ? "visible" : "invisible"} ${styles.add_remove_question} overflow-visible p-0`}
    >
      {addQuestionButton}
      <button
        // onClick={() => props.removeQuestion(pos)}
        onClick={() =>  props.modalDataHandler("Delete question", "Permanently remove question?", 'confirmation', () => props.removeQuestion(pos))}
        className={`${styles.removeQuestionButton}`}
      ></button>
    </div>
  );

  const ambitoButton = (
    <div
      className={`${displayButtons ? "visible" : "invisible"} ${styles.add_question} overflow-visible p-0`}
    >
      {addQuestionButton}
    </div>
  );

  const elementDropdownArrow = (
    <div
      className={`${srdStles.dropdownArrowContainer} overflow-visible p-0`}
    >
      <button
        onClick={
          () => {
            props.collapseElement(pos, !props.isCollapsed)
          }
        }
        className={`${srdStles.dropdownArrow} ${props.isCollapsed ? srdStles.down : srdStles.up} ${displayButtons ? "visible" : "invisible"}`}
      ></button>
    </div>
  );

  // const questionTypeButtons = (
  //   <div
  //     onBlur={hideQuestionTypeButtonsHandler}
  //     className={`${styles.questionTypeButtons} d-flex flex-column justify-content-center align-items-center`}
  //     disabled={questionTypeSelected}
  //   >
  //     <p className="mb-1" style={{ textAlign: "center", color: "black" }}>
  //       Choose question type:
  //     </p>
  //     <div className={`d-flex justify-content-center align-items-center`}>
  //       <button
  //         onClick={() => determineQuestionType("qualitative")}
  //         className={styles.qualitativeButton}
  //       >
  //         qualitative
  //       </button>
  //       <button
  //         onClick={() => determineQuestionType("quantitative")}
  //         className={styles.quantitativeButton}
  //       >
  //         quantitative
  //       </button>
  //     </div>
  //   </div>
  // );

  return (
    <tr
      onMouseEnter={(e) => {
        showQuestionButtons(e);
        showInfoIcon(e);
      }}
      onMouseLeave={(e) => {
        hideQuestionButtons(e);
        hideInfoIcon(e);
      }}
    >
      <td
        className={`
          ${titleStyle} ${styles.questionsWidth} 
          ${type && (srdStles.cursorPointer + ' ' + srdStles[`${type}Hover`])} 
          ${props.isCollapsed &&  srdStles[`${type}Valid`]}
          ${/*props.isCollapsed && (props.hasValidChildren ? srdStles[`${type}Valid`] : srdStles[`${type}Invalid`]) */"" }
          ${!type ? "px-2" : "p-0"}
          fw-bold text-start position-relative
        `}
        data-tip=""
      >
        {!type && props.questionType !== "quantitative" && questionsButtons}
        {type === "ambito" && props.ambitoType === "qualitative" && ambitoButton}
        {type && type !== "ambito" && elementDropdownArrow /* excluding ambiti because they have the plus button */}
        {/* {displayQuestionTypeButtons && questionTypeButtons} */}
        {!type ? (
          <div className="d-flex">
            {props.questionType !== "quantitative" ? (
              <div className={`${styles.questionId} ${styles.qltQstDisplayId} pe-2 me-2`}>{props.principioId}.{props.displayId && props.displayId}</div>
            ) : null}
            {props.questionType !== "quantitative" ? <textarea
              // disabled={!((!questionTypeSelected && props.isNewQuestion) || !props.isNewQuestion)}
              onKeyDown={changeTextareaHeight}
              placeholder="Type your question here"
              className={`${styles.inputField} fw-bold`}
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
              onBlur={() => {
                props.updateQuestion(pos, title);
              }}
            /> : <p className="m-0">{title}</p>}
          </div>
        ) : (
          <p 
            className="m-0 p-1 px-2"
            onClick={() => {
              if (type) {
                props.collapseElement(pos, !props.isCollapsed);
              }
            }}
          >{title}</p>
        )}
        {/* Tooltip */}
        <InfoIconWithTooltip text={props.tooltip} show={isInfoIconVisible} />
      </td>
      {Object.entries(props.opScopes).map(([key, value]) => (
        <td className={styles.opScopeWidth} key={pos + "-" + key}>
          <button
            // the value of the field determines if the checked symbol is shown
            className={value ? styles.checkedButton : styles.uncheckedButton}
            // return the operational scope field which is on string format
            onClick={() => {
              value
                ? props.unchecking(pos, type, key)
                : props.checking(pos, type, key);
            }}
          ></button>
        </td>
      ))}
    </tr>
  );
};

export default ChecklistRow;
